



















































import {
	computed,
	defineComponent,
	PropType,
	ref,
	nextTick,
	Ref,
} from '@vue/composition-api';
import Vue, { VueConstructor } from 'vue';
import { Size } from '@front-app/components/constants';
import { FocusableElement } from '@front-app/hooks/useAsyncModal';
import { GroupCategoriesStore } from '@front-app/store/singletons/GroupCategories';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import CategoryNameInput from './CategoryNameInput.vue';

enum RowMode {
	READ,
	EDIT,
}

export default defineComponent({
	components: {
		IconButton,
		FontAwesomeIcon,
		TrForm,
		FormSection,
		FormInput,
		FormLabel,
		CategoryNameInput,
	},
	props: {
		tag: {
			type: [String, Object] as PropType<string | VueConstructor>,
			default: 'div',
		},
		groupId: {
			type: String,
			required: true,
		},
		category: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		// Deleting
		const deleteStatus = useAsyncStatus();
		const deleteCategory = () => {
			deleteStatus.track(GroupCategoriesStore.deleteCategory(props.groupId, props.category));
		};

		// Editing
		const categoryRowEl: Ref<null | Vue> = ref(null);
		const editInputId = computed(() => `${props.category}-edit-input`);
		const currentMode = ref(RowMode.READ);
		const editStatus = useAsyncStatus();
		const newCategoryName = ref('');
		const beginEdit = async () => {
			newCategoryName.value = props.category;
			currentMode.value = RowMode.EDIT;
			await nextTick();
			if (categoryRowEl.value) {
				const el = categoryRowEl.value.$el.querySelector(`#${editInputId.value}`) as undefined | FocusableElement;
				if (el) {
					el.focus();
				}
			}
		};
		const clearEdit = () => {
			newCategoryName.value = '';
			editStatus.clear(0);
			currentMode.value = RowMode.READ;
		};
		const saveEdit = async () => {
			await editStatus.track(GroupCategoriesStore.renameCategory(props.groupId, props.category, newCategoryName.value));
			clearEdit();
		};
		return {
			// Delete
			deleteCategory,
			isDeleting: deleteStatus.isLoading,
			// Edit
			editInputId,
			editCategoryStatus: editStatus.status,
			newCategoryName,
			beginEdit,
			clearEdit,
			saveEdit,
			// Misc
			actionButtonSize: Size.MEDIUM,
			currentMode,
			RowMode,
		};
	},
});
